class ArticleNav {
  constructor(config = {}) {
    this.config = {
      headingSelectors: config.headingSelectors || 'h1',
      title: config.title || '目录',
      defaultExpanded: config.defaultExpanded !== undefined ? config.defaultExpanded : true,
      expandText: config.expandText || '展开',
      collapseText: config.collapseText || '收起'
    };
    
    this.content = document.querySelector('.article-template__content');
    this.wrapContent();
    this.createNavElement();
    this.headings = [];
    this.init();
  }

  // 包装文章内容
  wrapContent() {
    if (!this.content) return;
    
    const originalContent = this.content.innerHTML;
    
    const wrapper = document.createElement('div');
    wrapper.className = 'article-content-wrapper';
    
    const mainContent = document.createElement('div');
    mainContent.className = 'article-main-content';
    mainContent.innerHTML = originalContent;
    
    wrapper.appendChild(mainContent);
    this.content.innerHTML = '';
    this.content.appendChild(wrapper);
    
    this.content = mainContent;
  }

  // 创建导航DOM元素
  createNavElement() {
    if (!this.content) return;
    
    const nav = document.createElement('div');
    nav.className = 'article-nav mb-hide';
    nav.setAttribute('id', 'article-nav-id')
    if (!this.config.defaultExpanded) {
      nav.classList.add('article-nav--collapsed');
    }
    
    const header = document.createElement('div');
    header.className = 'article-nav__header';
    
    const title = document.createElement('div');
    title.className = 'article-nav__title';
    title.textContent = this.config.title;
    
    const toggle = document.createElement('div');
    toggle.className = 'article-nav__toggle';
    
    const toggleText = document.createElement('span');
    toggleText.className = 'article-nav__toggle-text';
    toggleText.textContent = this.config.defaultExpanded ? this.config.collapseText : this.config.expandText;
    
    const toggleIcon = document.createElement('span');
    toggleIcon.className = 'article-nav__toggle-icon';
    toggleIcon.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.00404 9.82825L8.62151 9.21078L12.2261 5.60622L12.2257 5.60589C12.2303 5.60177 12.2347 5.59756 12.239 5.59325C12.4099 5.42239 12.4099 5.14539 12.239 4.97453C12.0682 4.80368 11.7912 4.80368 11.6203 4.97453C11.616 4.97888 11.6118 4.98335 11.6077 4.98783L11.6074 4.9875L8.00281 8.59205L4.37875 4.96799C4.20789 4.79713 3.93089 4.79713 3.76003 4.96799C3.58917 5.13885 3.58917 5.41585 3.76003 5.58671L8.00281 9.82949L8.00404 9.82825Z" fill="black"/>
      </svg>
    `
    
    toggle.appendChild(toggleText);
    toggle.appendChild(toggleIcon);

    const closeIcon = document.createElement('span');
    closeIcon.className = 'article-nav__close-icon';
    closeIcon.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8519 10.0031L16.4884 4.36623C16.5445 4.31025 16.589 4.24375 16.6194 4.17054C16.6497 4.09733 16.6654 4.01885 16.6654 3.93959C16.6654 3.86033 16.6497 3.78185 16.6194 3.70864C16.589 3.63543 16.5445 3.56894 16.4884 3.51296C16.4324 3.45684 16.3659 3.41233 16.2927 3.38195C16.2195 3.35157 16.141 3.33594 16.0618 3.33594C15.9825 3.33594 15.904 3.35157 15.8308 3.38195C15.7576 3.41233 15.6911 3.45684 15.6352 3.51296L9.9987 9.14985L4.36224 3.51296C4.30627 3.45684 4.23978 3.41233 4.16657 3.38195C4.09337 3.35157 4.01489 3.33594 3.93564 3.33594C3.85639 3.33594 3.77791 3.35157 3.70471 3.38195C3.6315 3.41233 3.56501 3.45684 3.50904 3.51296C3.45293 3.56894 3.40841 3.63543 3.37804 3.70864C3.34767 3.78185 3.33203 3.86033 3.33203 3.93959C3.33203 4.01885 3.34767 4.09733 3.37804 4.17054C3.40841 4.24375 3.45293 4.31025 3.50904 4.36623L9.1455 10.0031L3.50904 15.64C3.42456 15.7243 3.367 15.8318 3.34367 15.9488C3.32033 16.0658 3.33226 16.1872 3.37796 16.2974C3.42365 16.4076 3.50104 16.5018 3.60033 16.568C3.69961 16.6342 3.81631 16.6695 3.93564 16.6693C4.09028 16.6693 4.24359 16.6106 4.36224 16.4933L9.9987 10.8564L15.6352 16.4933C15.7525 16.6106 15.9071 16.6693 16.0618 16.6693C16.2164 16.6693 16.371 16.6106 16.4884 16.4933C16.5445 16.4373 16.589 16.3708 16.6194 16.2976C16.6497 16.2244 16.6654 16.1459 16.6654 16.0667C16.6654 15.9874 16.6497 15.9089 16.6194 15.8357C16.589 15.7625 16.5445 15.696 16.4884 15.64L10.8519 10.0031Z" fill="black"/>
      </svg>
    `
    
    header.appendChild(title);
    header.appendChild(toggle);
    header.appendChild(closeIcon);
    
    const list = document.createElement('ul');
    list.className = 'article-nav__list';
    list.id = 'articleNav';
    
    nav.appendChild(header);
    nav.appendChild(list);
    
    this.content.parentElement.appendChild(nav);
    console.log(nav)
    if (nav) {
      document.body.classList.add('blog-has-menu')
    }
    // 添加展开/收起功能
    toggle.addEventListener('click', () => {
      const isCollapsed = nav.classList.toggle('article-nav--collapsed');
      toggleText.textContent = isCollapsed ? this.config.expandText : this.config.collapseText;
      
      // 如果展开，设置列表的最大高度
      if (!isCollapsed) {
        list.style.maxHeight = list.scrollHeight + 'px';
      }
    });
    
    this.nav = list;
    this.navContainer = nav;
  }

  init() {
    if (!this.content || !this.nav) return;
    
    // 获取配置的标题标签
    this.headings = Array.from(this.content.querySelectorAll(this.config.headingSelectors));
    
    // 如果没有标题，隐藏导航
    if (this.headings.length === 0) {
      this.navContainer.style.display = 'none';
      return;
    }

    // 为每个标题创建导航项
    this.headings.forEach((heading, index) => {
      const id = `heading-${index}`;
      heading.id = id;

      const li = document.createElement('li');
      li.className = 'article-nav__item';
      
      const a = document.createElement('a');
      a.href = `#${id}`;
      a.className = 'article-nav__link';
      a.textContent = heading.textContent;
      
      li.appendChild(a);
      this.nav.appendChild(li);

      a.addEventListener('click', (e) => {
        e.preventDefault();
        
        // 移除所有链接的高亮状态
        this.nav.querySelectorAll('.article-nav__link').forEach(link => {
          link.classList.remove('active');
        });
        
        // 为当前点击的链接添加高亮状态
        a.classList.add('active');
        
        // 记录当前滚动位置
        const currentScrollY = window.scrollY;
        const targetElement = heading;
        const targetPosition = targetElement.offsetTop;
        
        heading.scrollIntoView({ behavior: 'auto', block: 'center' });
        
        // 滚动完成后，只有从下往上滚动时才向上偏移
        // setTimeout(() => {
        //   if (currentScrollY > targetPosition) {
        //     // 从下往上滚动，向上偏移一些距离
        //     window.scrollBy(0, -200);
        //   }
        // }, 500);
      });
    });

    // 设置列表初始最大高度
    if (this.config.defaultExpanded) {
      this.nav.style.maxHeight = this.nav.scrollHeight + 'px';
    }

    this.addScrollSpy();
  }

  addScrollSpy() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.id;
        const navLink = this.nav.querySelector(`[href="#${id}"]`);
        
        if (entry.isIntersecting) {
          this.nav.querySelectorAll('.article-nav__link').forEach(link => {
            link.classList.remove('active');
          });
          navLink?.classList.add('active');
        }
      });
    }, {
      rootMargin: '-20% 0px -80% 0px'
    });

    this.headings.forEach(heading => observer.observe(heading));
  }
}

// 初始化
window.addEventListener('DOMContentLoaded', () => {
  new ArticleNav({
    headingSelectors: 'h2',
    title: 'Table of Contents',
    defaultExpanded: true,
    expandText: 'Expand',
    collapseText: 'Retract'
  });
  const menuTriggerBtn = document.getElementById('menu-trigger-btn');
  const menu = document.getElementById('article-nav-id')
  const closeBtn = document.querySelector('.article-nav__close-icon');
  const links = document.querySelectorAll('.article-nav__link');


  function createMask() {
    var mask = document.createElement('div');
    mask.className = 'menu-class';
    mask.style.position = 'fixed';
    mask.style.top = '0';
    mask.style.left = '0';
    mask.style.width = '100%';
    mask.style.height = '100%';
    mask.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    mask.style.zIndex = '10';
    mask.style.display = 'block';
    
    mask.addEventListener('touchmove', function(e) {
      e.preventDefault();
    }, { passive: false });
    document.body.appendChild(mask);
  }
  function removeMask() {
    const mask = document.querySelector('.menu-class');
    if (mask) {
      mask.remove(); // 彻底移除元素
      document.body.style.overflow = 'auto'; // 恢复滚动
      // 可选：清理事件监听器（防内存泄漏）
      mask.removeEventListener('touchmove', preventScroll);
    }
  }
  // 滚动穿透处理函数（需与创建时一致）
  function preventScroll(e) { 
    e.preventDefault(); 
  }
  menuTriggerBtn.addEventListener('click', () => {
    menu.classList.remove('mb-hide');
    createMask();
  })
  closeBtn.addEventListener('click', () => {
    menu.classList.add('mb-hide');
    removeMask()
  })
  links.forEach(link => {
    link.addEventListener('click', () => {
      menu.classList.add('mb-hide');
      removeMask()
    })
  })
});















